import { ISchedules } from '../../../../services/journey.service';
import { compareDates, scheduleIsEnded } from '../../../../lib/dayjs';
import { sliceToLimit, hasMoreThanLimit } from '../../../../lib/pagination';

const EXCLUDED_STATUSES = ['CANCELED', 'RESCHEDULED'];

export default class SchedulesModel {
  static filterValid(schedules: ISchedules[]): ISchedules[] {
    return (schedules ?? []).filter(schedule => !EXCLUDED_STATUSES.includes(schedule.status));
  }

  static getActiveSchedules(schedules: ISchedules[]): ISchedules[] {
    return SchedulesModel.filterValid(schedules)
      .filter(schedule => !scheduleIsEnded(schedule.dateEnd))
      .sort((a, b) => compareDates(a.dateEnd, b.dateEnd));
  }

  static getPastSchedules(schedules: ISchedules[]): ISchedules[] {
    return SchedulesModel.filterValid(schedules)
      .filter(schedule => scheduleIsEnded(schedule.dateEnd))
      .sort((a, b) => compareDates(b.dateStart, a.dateStart));
  }

  static getPreview(schedules: ISchedules[], max: number): ISchedules[] {
    return sliceToLimit(schedules, max);
  }

  static hasMore(schedules: ISchedules[], max: number): boolean {
    return hasMoreThanLimit(schedules.length, max);
  }

  static isPlaceholder(schedules: ISchedules[]): boolean {
    return schedules.length === 1 && schedules[0].id === '';
  }
}
